import React from 'react'
import Box from '@material-ui/core/Box'
import Skeleton from '@material-ui/lab/Skeleton'

const DialogLoader = () => {
  return <Box display="flex" justifyContent="center" gridColumnGap={16} p={2}>
    <Skeleton variant="circle" width={16} height={16} />
    <Skeleton variant="circle" width={16} height={16} />
    <Skeleton variant="circle" width={16} height={16} />
  </Box>
}

export default DialogLoader
